import React from 'react';

import SvgIcon from '@material-ui/core/SvgIcon';
import {
  TEACHERS_HOME_URL,
  TEACHERS_MEETINGS_LIST_URL,
  TEACHERS_STUDENTS_LIST,
  TEACHER_ASSIGNMENTS_V2_URL
} from 'config/urls';
import { ReactComponent as ResultsIcon } from 'images/results.svg';

import { ReactComponent as AssignmentsIcon } from './assets/assignments.svg';
import { ReactComponent as HomeIcon } from './assets/home.svg';
import { ReactComponent as MeetingsIcon } from './assets/meetings.svg';

const HOME_PAGE_ENABLED = process.env.REACT_APP_HOME_PAGE_ENABLED === 'true';

export const getLeftNavigationItems = ({ user, isMobile }) => {
  const userIsPaidUser = user.is_paid;

  if (!userIsPaidUser) {
    return [
      {
        key: 'assignments',
        text: 'Assignments',
        url: TEACHER_ASSIGNMENTS_V2_URL,
        Icon: (props) => <SvgIcon {...props} component={AssignmentsIcon} />
      }
    ];
  }

  return [
    HOME_PAGE_ENABLED && {
      key: 'home',
      text: 'Home',
      url: TEACHERS_HOME_URL,
      Icon: (props) => (
        <SvgIcon {...props} component={HomeIcon} viewBox="0 0 16 16" />
      )
    },
    {
      key: 'assignments',
      text: 'Assignments',
      url: TEACHER_ASSIGNMENTS_V2_URL,
      Icon: (props) => <SvgIcon {...props} component={AssignmentsIcon} />
    },
    {
      key: 'students',
      text: 'Students',
      url: TEACHERS_STUDENTS_LIST,
      Icon: (props) => <SvgIcon {...props} component={ResultsIcon} />
    },
    {
      key: 'meetings',
      text: 'Meetings',
      Icon: (props) => <SvgIcon {...props} component={MeetingsIcon} />,
      url: TEACHERS_MEETINGS_LIST_URL
    }
  ].filter(Boolean);
};
